<script setup lang="ts">
  import type { ClpUploadStoryblok } from '@/storyblok/component-types-sb'

  const { t } = useI18n()

  const props = withDefaults(
    defineProps<{
      price: number
      direction: string
      isSelected: boolean
      selectedDirection: string
      cherryIcon?: ClpUploadStoryblok['cherryIcon']
      isSoldOut?: boolean
      destination: string
    }>(),
    {
      cherryIcon: 'common/cherry',
      isSoldOut: false
    }
  )

  const emit = defineEmits(['selectDirection'])
  const getPriceItemClass = computed(() => {
    if (props.isSelected) {
      return 'border-2 border-bt-blue-ui shadow-sm'
    }

    return 'border-border hover:border-2 hover:border-bt-blue-ui'
  })

  const ariaText = computed(() => {
    const directionKey = 'clp.' + props.direction
    const soldOutText = props.isSoldOut ? ' ' + t('clp.soldOut') : ''
    const selectedText = props.isSelected ? ' ' + t('aria.selected') : ''

    return `${props.destination} ${t(directionKey)} ${t('clp.priceFrom')} ${props.price}€${soldOutText}${selectedText}`
  })
</script>
<template>
  <button
    class="mb-4 flex w-full cursor-pointer justify-between rounded-sm border px-4 py-3"
    :class="getPriceItemClass"
    tabindex="0"
    :aria-label="ariaText"
    @click="emit('selectDirection', direction)"
  >
    <div class="text-sm">{{ $t(`clp.${direction}`) }}</div>
    <div
      class="flex"
      :class="{ 'text-secondary': isSoldOut }"
    >
      <span class="mr-1 text-xs">{{ $t('clp.priceFrom') }}</span>
      <span class="text-lg">{{ price }}€</span>
      <Icon
        v-if="!isSoldOut"
        :name="cherryIcon"
        filled
      />
    </div>
  </button>
</template>
